import React from "react";
import { formatAddress } from "../helperFunctions/pdfFunctions";
import { useHistory } from "react-router-dom";
import { dateTimeFormatter } from "../helperFunctions/dateFormatters";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import PhoneIcon from "@mui/icons-material/Phone";
import HomeIcon from "@mui/icons-material/Home";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import {
  findOnGoogleMaps,
  searchEmail,
} from "../helperFunctions/navigationHelpers";

function ContactCard({
  editPrimary,
  data,
  addAsJobsheet,
  isMarked,
  inEditMode,
}) {
  const history = useHistory();
  let addressLine = formatAddress(data);
  let marked = isMarked(data?.uid);

  function navigateToContact(data) {
    if (!inEditMode) {
      history.push(`/${data.primaryType}/${data.uid}`, {
        data,
        preservePrimary: true,
      });
    }
  }

  return (
    <div
      onClick={() => {
        editPrimary(data);
      }}
      className="contactCard"
    >
      <div className="contact-card-header">
        <p className="name">{data?.authorisedBy || "No Name"}</p>

        <div className="contact-header-controls">
          <p className={`ref-number ${data?.primaryType || ""}`}>
            {data?.refNumber}
          </p>
          <button title="Add as Jobsheet" onClick={() => addAsJobsheet(data)}>
            <AddCircleIcon style={{ fontSize: "28px" }} className="icon" />
          </button>
        </div>
      </div>

      <div className="contact-card-body">
        <div className="emails">
          <button
            data-searchtype="email"
            name="email"
            className="emailSearch"
            onClick={(e) => searchEmail(e, data?.email)}
          >
            <AlternateEmailIcon className="icon" />
          </button>
          <p>{data?.email}</p>
        </div>
        <div className="location">
          <button
            onClick={() => findOnGoogleMaps(data?.address, data?.postcode)}
          >
            <HomeIcon className="icon" />
          </button>
          <div className="address">
            <p>{addressLine}</p>
            <p>{data?.address2}</p>
            <p>{data?.postcode}</p>
          </div>
        </div>
        <div className="phone-numbers">
          <PhoneIcon className="icon" />
          <p>{data?.number}</p>
          <p>{data?.homeNumber}</p>
        </div>
      </div>

      <div className="contact-card-footer">
        <div className="job-details">
          <p className="date">
            {dateTimeFormatter(
              data?.bookedInDateTime || data?.jobReceived,
              "d_medium"
            )}
          </p>
          <p className="job-description">{data?.jobDetails}</p>
        </div>

        {/* <Link to={`/${data.primaryType}/${data.uid}`}> */}
        <div
          onClick={() => navigateToContact(data)}
          className={`primary-link ${data?.primaryType || ""} ${
            inEditMode ? "disable-animation" : ""
          }`}
        >
          <ArrowCircleRightIcon className="icon" />
        </div>
        {/* </Link> */}
      </div>

      {marked ? <div className="marked-item"></div> : null}
    </div>
  );
}

export default ContactCard;
